var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 24,
    viewBox: "0 0 39 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow down"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3911 13.299C38.1086 12.8848 38.3544 11.9674 37.9402 11.25C37.526 10.5326 36.6086 10.2868 35.8911 10.701L19.3206 20.268L2.75007 10.701C2.03263 10.2868 1.11524 10.5326 0.70103 11.25C0.286816 11.9674 0.53263 12.8848 1.25007 13.299L18.5469 23.2854C18.5941 23.3138 18.6428 23.3395 18.6927 23.3624C18.8948 23.4558 19.109 23.5005 19.3208 23.5003C19.5325 23.5004 19.7465 23.4558 19.9485 23.3624C19.9984 23.3394 20.0471 23.3138 20.0943 23.2854L37.3911 13.299Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3911 3.29904C38.1086 2.88483 38.3544 1.96745 37.9402 1.25001C37.526 0.532567 36.6086 0.286755 35.8911 0.700968L19.3206 10.268L2.75007 0.700969C2.03263 0.286755 1.11524 0.532568 0.70103 1.25001C0.286816 1.96745 0.53263 2.88483 1.25007 3.29904L18.5469 13.2854C18.5941 13.3138 18.6428 13.3395 18.6927 13.3624C18.8948 13.4558 19.109 13.5005 19.3208 13.5003C19.5325 13.5004 19.7465 13.4558 19.9485 13.3624C19.9984 13.3394 20.0471 13.3138 20.0943 13.2854L37.3911 3.29904Z",
    fill: "white",
    fillOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.af9afc235607d16dc53caffaee2bf1ab.svg";
export { ForwardRef as ReactComponent };